export const PERSIST_STORAGE_KEY = "persist:root";

export const clearPersistedStoreInLocalStorage = () => {
  localStorage.removeItem(PERSIST_STORAGE_KEY);
};

/*
 * 1112 ticket
 * TO DO
 * Remove the following functions if they eventually are unused
 *  */
export const getParsedValueFromStorage = storageKey => {
  const stickyValue = window.localStorage.getItem(storageKey);
  let value;

  try {
    value = JSON.parse(stickyValue);
  } catch (error) {
    return stickyValue;
  }

  return value;
};

export const setValueToLocalStorage = (storageKey, value) => {
  window.localStorage.setItem(
    storageKey,
    typeof value !== "object" ? value : JSON.stringify(value)
  );
};
